import Input from "../Component/Input";

export const ContactInfo = [
  { tag: Input, img: "phone", label: "Phone", name: "phoneNumber",required:true,validation:"phone" },
  { tag: Input, img: "email", label: "Email", name: "email",required:true,validation:"email" },
  { tag: Input, img: "password", label: "Password", name: "password",required:true,validation:"password" },
];
